/* eslint-disable max-len */
import React, { useEffect, useState, useRef } from 'react';
import { useStoreId } from '@thd-nucleus/experience-context';
import { useSearchDeprecated, useRelatedSearchNavDeprecated } from '@thd-nucleus/data-sources/react/dataModel/migration';
import { useDataModel } from '@thd-nucleus/data-sources';
import { RelatedSearchLinks } from '../subcomponents/RelatedSearchLinks';
import { RelatedSearchProducts } from '../subcomponents/RelatedSearchProducts';
import { PopularCategory } from '../subcomponents/PopularCategory';
import { RecentSearch } from '../subcomponents/RecentSearch';
import { RelatedSearchPlaceholder } from './RelatedSearchPlaceholder';
import { dataModelRelatedSearch, defaultPropsRelatedSearch, propTypesRelatedSearch } from './constants';

// @todo this should really be 2 components, one for search and one for product.
const RelatedSearchComponent = (props) => {
  const {
    itemId,
    keyword,
    navParam,
    recent,
    limitItems,
    noOfItems,
    storeId: defaultStoreId,
    isPopularCategory,
    pageType,
  } = props;

  const {
    searchData: searchDataProps,
    searchError: searchErrorProps,
    searchLoading: searchLoadingProps
  } = props;

  let searchData;
  let searchError;
  let searchLoading;

  if (recent) {
    return <RecentSearch limitItems={limitItems} noOfItems={noOfItems} />;
  }

  const storeId = defaultStoreId || useStoreId();
  const [loadedStoreId, setLoadedStoreId] = useState(() => storeId);

  const hasPropData = !!(searchDataProps || searchErrorProps || typeof searchLoadingProps !== 'undefined');
  ({
    data: searchData,
    error: searchError,
    loading: searchLoading
  } = useSearchDeprecated({
    domains: ['relatedResults'],
    storeId,
    keyword,
    skip: isPopularCategory || (!keyword || hasPropData),
    ssr: true
  }));

  if (hasPropData) {
    searchData = searchDataProps;
    searchError = searchErrorProps;
    searchLoading = searchLoadingProps;
  }

  const loadedStoreRef = useRef(storeId);
  const {
    data: navData,
    error: navError,
    loading: navLoading,
    variables,
  } = useRelatedSearchNavDeprecated({
    domains: ['relatedSearch', 'products'],
    productDomains: ['mediaSlim', 'identifiers', 'details'],
    navParam,
    storeId,
    itemId,
    skip: isPopularCategory || (!navParam && !itemId),
    ssr: true
  });

  const options = {
    variables: {},
    skip: !!itemId || !!navParam || !!keyword
  };
  const { data: popCatData, loading: popCatLoading, error: popCatError } = useDataModel('popularCategories', options);

  if (!navLoading && navData && variables.storeId) {
    if (variables.storeId !== loadedStoreId) {
      loadedStoreRef.current = variables.storeId;
    }
  }

  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('related-search.ready'); }, []);

  if (searchLoading || navLoading || popCatLoading) {
    return (<RelatedSearchPlaceholder />);
  }

  const searchDataIssue = ((searchError && !searchData) || !searchData || searchLoading) && (keyword);
  const navDataIssue = ((navError && !navData) || !navData || navLoading) && (navParam);
  const popCatIssue = ((popCatError && !popCatData) || !popCatData || popCatLoading) && isPopularCategory;

  const relatedSearchModel = searchData?.searchModel;
  const relatedNavModel = navData?.relatedSearchModel;
  const relatedSearchModelKeywords = !relatedSearchModel?.relatedResults?.relatedKeywords?.length ? null
    : relatedSearchModel?.relatedResults?.relatedKeywords;

  const relatedKeywords = relatedSearchModelKeywords || relatedNavModel?.relatedSearch;
  const relatedProducts = navData?.relatedSearchModel?.products || [];

  const popularCategories = popCatData?.popularCategories;
  const isSearchPage = pageType.toLowerCase() === 'search';

  if ((searchDataIssue || navDataIssue) || popCatIssue) {
    return null;
  }
  return (
    <div className="related-search" data-component="RelatedSearch">
      <div className="sui-flex sui-flex-col sui-w-full sui-gap-8">
        {
          !!relatedKeywords?.length
          && <RelatedSearchLinks relatedLinks={relatedKeywords} />
        }
        {
          !!relatedProducts?.length
          && <RelatedSearchProducts relatedSearchProducts={relatedProducts} />
        }
        {
          !!popularCategories?.length && !isSearchPage && <PopularCategory relatedLinks={popularCategories} />
        }
      </div>
    </div>
  );
};

RelatedSearchComponent.displayName = 'RelatedSearch';

RelatedSearchComponent.propTypes = propTypesRelatedSearch;

RelatedSearchComponent.defaultProps = defaultPropsRelatedSearch;

RelatedSearchComponent.dataModel = dataModelRelatedSearch;

export { RelatedSearchComponent };
